import { Tooltip, IconButton, useDisclosure } from '@chakra-ui/react';
import { Icons, defaultIconSize } from '../../Icons';
import { GeneratePaFromGroupsModal } from '../../productApproval/GeneratePaFromGroupsModal';
import { SampleNextActionProps } from '../SampleNextAction';
import { useTranslation } from 'react-i18next';

export function InitiateSampling(props: SampleNextActionProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation();

  return (
    <>
      <Tooltip label={t('sample.initate')}>
        <IconButton
          onClick={onOpen}
          size="sm"
          icon={<Icons.Gift boxSize={defaultIconSize} />}
          aria-label={t('sample.initate')}
        />
      </Tooltip>
      <GeneratePaFromGroupsModal
        onClose={onClose}
        groupIds={[props.groupId]}
        isOpen={isOpen}
      />
    </>
  );
}
